<script>
	import { Circle } from "svelte-loading-spinners";
</script>

<div
	class="spinner-border m-0 spinner-border-md text-warning d-flex justify-content-center align-items-center"
>
	<span class="sr-only" />
</div>
